<template>
  <div class="invoice">
    <Spinner :loading="statement.loading" />
    <div class="inv-inner" v-if="!statement.loading">
      <!-- Invoice Header -->
      <div class="inv-header">
        <Icon class="h-6 w-auto" name="logo" />
        <div class="inv-number">
          <span>Account Summary</span>
          <p>As of {{ moment(new Date()) }}</p>
        </div>
      </div>
      <div class="inv-icon">
        <span><Icon name="summary-icon"/></span>
      </div>
      <!-- Invoice Content -->
      <div class="inv-details">
        <div class="address">
          <div>
            <span class="small">Customer</span>
            <p>{{ statement.data.company?.name }}</p>
            <!-- <span>
              9 Woodland Rd. Suite D<br />
              Roseland, NJ 07068
            </span> -->
          </div>
        </div>
        <div class="details">
          <button
            :disabled="loader"
            :class="[
              'inline-flex items-center space-x-1 px-4 py-1.5 rounded leading-none text-white',
              loader ? 'bg-gray-500 cursor-not-allowed' : 'bg-theme-secondary',
            ]"
            @click="downloadInvoice()"
          >
            <Spinner :loading="loader" className="w-3.5 h-3.5" v-if="loader" />
            <DownloadIcon class="w-3.5 h-3.5" v-else />
            <span>Download</span>
          </button>
        </div>
      </div>
      <!-- List Items -->
      <div class="inv-list">
        <table>
          <thead class="inv-list-header">
            <tr>
              <th><span>Order</span></th>
              <th :width="200"><span>Invoice</span></th>
              <th :width="200"><span>Oder Date</span></th>
              <th :width="200"><span>Due Date</span></th>
              <th :width="200"><span class="w-full text-right">Current</span></th>
              <th :width="200"><span class="w-full text-right">1-30</span></th>
              <th :width="200"><span class="w-full text-right">31-60</span></th>
              <th :width="200"><span class="w-full text-right">61-90</span></th>
              <th :width="250"><span class="w-full text-right">91+</span></th>
            </tr>
          </thead>
          <tbody class="inv-list-items">
            <tr class="inv-list-item" v-for="s in statement.data.statements" :key="s.order_number">
              <td class="text">
                <span>{{ s.order_number }}</span>
              </td>
              <td class="text">{{ s.invoice_number }}</td>
              <td class="text">{{ moment(s.order_date, "MM/DD/YY") }}</td>
              <td class="text">{{ moment(s.due_date, "MM/DD/YY") }}</td>
              <td>{{ getValue(s["total_balance"]) }}</td> 
              <td>{{ getValue(s["1_30"]) }}</td>
              <td>{{ getValue(s["31_60"]) }}</td>
              <td>{{ getValue(s["61_90"]) }}</td>
              <td>{{ getValue(s["91+"]) }}</td>
            </tr>
          </tbody>
        </table>
        <div class="inv-pricing">
          <div class="tax-pricings"></div>
          <div class="order-pricings">
            <div class="price-item highlight no-border ">
              <p>Total Balance</p>
              <span>
                ${{
                  commaFormat(
                    Number(
                      parseFloat(statement.data.totals.total_balance)).toFixed(2)
                  )
                }}
              </span>
            </div>
            <div class="price-item highlight no-border ">
              <p>Total Overdue</p>
              <span>
                ${{
                  commaFormat(
                    Number(
                      parseFloat(statement.data.totals.total_overdue)).toFixed(2)
                  )
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- Invoice Footer -->
      <div class="inv-footer">
        <span
          >Medusa Distribution LLC 9 Woodland Rd., Suite D,<br />
          Roseland, NJ, 07068, US
        </span>
        <div class="info">
          <span>Email sales@medusadistribution.com</span>
          <span>Phone 973-808-1101</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DownloadIcon } from "@heroicons/vue/outline";
import Mymixin from "@/modules/mixins";
import Account from "@/modules/Account";

import { ref } from "vue";

export default {
  name: "Invoice",
  mixins: [Mymixin],
  components: {
    DownloadIcon,
  },
  methods: {
    moment: function(date, format) {
      if(format){
        return moment(date).format(format);
      }
      return moment(date).format("MMM Do YYYY");
    },

    getValue: function(x) {
      if (x) {
        return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return null;
    },
  },
  setup() {
    const loader = ref(false);

    const { statement, getAccountStatement } = Account();
    getAccountStatement();
    
    const downloadInvoice = () => {
      let temp = document.title;
      document.title = "Account Statement";
      window.print();
      document.title = temp;
    };
    
    return {
      downloadInvoice,
      statement,
      loader,
    };
  },
};
</script>
<style lang="scss" scoped>
.invoice {
  @apply w-full h-full p-8;
  .inv-inner {
    @apply max-w-5xl mx-auto bg-white;
  }
  .inv-header {
    @apply w-full px-10 py-8 flex items-center justify-between;
    background: #f8f8f8;
    .inv-number {
      @apply flex flex-col items-start text-sm font-medium;
      color: rgba(72, 90, 93, 0.54);
      p {
        @apply text-base;
        color: #485a5d;
      }
    }
  }
  .inv-icon {
    @apply w-full flex items-center justify-center pb-10;
    span {
      @apply flex items-center justify-center w-14 h-14 border  rounded-full flex-shrink-0 bg-white -mt-7;
      border-color: #dbdbdb;
      svg {
        @apply w-9 h-9;
      }
    }
  }
  .inv-details {
    @apply flex items-start justify-between text-sm text-theme-body px-4 pb-8 leading-normal;
    .small {
      @apply inline-block text-xs text-theme-body uppercase font-normal mb-2.5;
    }
    .address {
      @apply flex flex-col space-y-5;
      > div {
        @apply w-full;
      }
      p {
        @apply text-theme-secondary mb-1;
      }
    }
    .details {
      .detail-item {
        @apply flex items-center py-1;
        span {
          @apply w-40;
        }
        p {
          @apply text-theme-secondary text-left;
        }
      }
    }
  }
  .inv-list {
    .inv-list-header {
      @apply py-4 border-b;
      border-color: rgba(180, 180, 180, 0.25);
      th {
        @apply text-theme-body font-normal uppercase text-sm text-left px-4 py-1.5 whitespace-nowrap;
        span {
          @apply block;
        }
      }
    }
    .inv-list-items {
      @apply w-full px-10 divide-y divide-gray-100;
      .inv-list-item {
        @apply py-3 text-md text-theme-body font-light;
        .total {
          @apply font-medium text-theme-dark;
        }
        td {
          @apply text-theme-secondary font-normal uppercase text-sm text-right px-4 py-2.5 whitespace-nowrap;
          &.text {
            @apply text-left;
          }
          span {
            @apply font-normal;
          }
        }
      }
    }
  }
  .inv-pricing {
    @apply grid grid-cols-2 py-5 px-4 mb-12 border-t gap-32;
    border-color: rgba(180, 180, 180, 0.25);
    .order-pricings {
      @apply flex flex-col items-end;
    }
    .taxt-pricings {
      @apply flex flex-col items-start;
    }
    .price-item {
      @apply inline-flex items-center justify-between flex-shrink-0 w-full text-md text-theme-dark-shade font-light space-y-1.5;
      p {
        @apply w-3/5;
      }
      span {
        @apply w-2/5 text-right;
      }
      &.highlight {
        @apply text-theme-secondary font-medium py-2 border-t mt-2;
        border-color: rgba(180, 180, 180, 0.25);
        &.no-border {
          @apply border-none py-0 mt-0;
        }
      }
      &.extra {
        @apply font-medium text-sm;
        color: #8fa3a9;
      }
    }
  }
  .inv-footer {
    @apply w-full px-4 py-6 border-t  flex items-start justify-between text-sm font-light text-theme-body leading-normal;
    border-color: rgba(180, 180, 180, 0.25);
    span {
      @apply block;
    }
  }
  .pay-status {
    @apply flex flex-col items-end mb-8 space-y-3;
    span {
      @apply uppercase font-normal text-black inline-block px-3 py-1.5 rounded border  leading-none text-xs w-24 text-center;
      &.paid {
        @apply border-green-500 bg-green-50;
      }
      &.unpaid {
        @apply border-red-500 bg-red-50;
      }
      &.partial {
        @apply border-yellow-500 bg-yellow-50;
      }
    }
  }
}
</style>